define(["require", "exports", "Products/Tracking", "UI/Context", "UI/Viewport", "utility/knockout-utils"], function (require, exports, Tracking_1, Context_1, Viewport_1, knockout_utils_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    class ComponentBase {
        constructor(props, componentContextData) {
            this.dispose = () => {
                for (let disposable of this._disposables) {
                    disposable.dispose();
                }
            };
            this.SetComponentTracking = (tracking) => {
                this._componentContextData.tracking = tracking;
            };
            this.TrackEvent = (tracking) => {
                var trackingStack = [tracking];
                var context = this._componentContextData;
                while (context != null) {
                    trackingStack.push(context.tracking);
                    context = context.parentContext;
                }
                (0, Tracking_1.TrackEvent)(trackingStack.reverse());
            };
            this.OnToggleClick = (cb) => (model, event) => {
                let checked = event.target.checked;
                if (typeof checked !== 'undefined') {
                    let value = (cb && cb(model)) || model;
                    let checkedLabel = checked ? 'On' : 'Off';
                    if (typeof value === 'string') {
                        this.TrackEvent({ Label: value + "|" + checkedLabel });
                    }
                    else if (typeof value === 'object') {
                        let useLabel = value.Label || "";
                        if (useLabel) {
                            useLabel += "|";
                        }
                        this.TrackEvent(Object.assign(Object.assign({}, value), { Label: useLabel + checkedLabel }));
                    }
                }
                return true;
            };
            this.Viewport = ComponentBase.Viewport;
            this._componentContextData = componentContextData;
            this._disposables = [];
            this._el = componentContextData.componentInfo.koComponentInfo.element;
            this.InstanceId = componentContextData.componentInfo.instanceId;
            this.ParentInstanceId = componentContextData.parentContext && componentContextData.parentContext.componentInfo.instanceId || null;
            this.Props = ko.pureComputed(() => ko.unwrap(props));
            this.Context = Context_1.default;
        }
        AddDisposableListener(el, type, listener, options) {
            el.addEventListener(type, listener, options);
            this._disposables.push({
                dispose: () => {
                    el.removeEventListener(type, listener);
                }
            });
        }
        GetTrackEventData(e, key) {
            // Handle user-initiated (DOM) events
            if (e && e.originalEvent) {
                // SELECT "change" event
                if (e.type == "change" && e.originalEvent.target["tagName"] == "SELECT") {
                    return { [key]: e.originalEvent.target["value"] };
                }
                // INPUT "change" event
                if (e.type == "change" && e.originalEvent.target["tagName"] == "INPUT") {
                    return { [key]: e.originalEvent.target["value"] };
                }
                return {};
            }
            // SELECT "select2:select" event
            if (e && e.type == "select2:select" && e.target["tagName"] == "SELECT") {
                return { Label: e.target["value"] };
            }
            return null;
        }
        TrackDOMEvent(data, e, ...args) {
            return this.WithDOMEventTracking()(data, e, ...args);
        }
        WithTrackingDataTransform(transformer, inContext = this) {
            const handleWithTracking = (data, e, ...args) => {
                const transformedData = transformer(data, e, ...args);
                transformedData && inContext.TrackEvent(transformedData);
                return true;
            };
            return (0, knockout_utils_1.HandleOrProxy)(handleWithTracking);
        }
        WithTracking(eventTrackingData, inContext = this) {
            const handleWithTracking = (data, e, ...args) => {
                eventTrackingData && inContext.TrackEvent(eventTrackingData);
                return true;
            };
            return (0, knockout_utils_1.HandleOrProxy)(handleWithTracking);
        }
        WithDOMEventTracking(key = "Label", trackingData, inContext = this) {
            return this.WithTrackingDataTransform((data, e) => {
                const trackingDataFromEvent = this.GetTrackEventData(e, key);
                return trackingDataFromEvent ? Object.assign(Object.assign({}, trackingData), trackingDataFromEvent) : null;
            }, inContext);
        }
    }
    exports.default = ComponentBase;
    ComponentBase.Viewport = new Viewport_1.Viewport();
});
//# sourceMappingURL=component-base.js.map